import { EarthBrainViewerAPIs } from "./API/EarthBrainViewerAPIs";
import { ArbitraryLineAPIs } from "./API/arbitrary-line";
import { Drawing2DImageAPIs } from "./API/drawing-2d-image-APIs";
import { DXFAPIs } from "./API/dxf-apis";
import { FlatGroundAPIs } from "./API/flat-ground";
import { LineWorkAPIs } from "./API/lineworks";
import { MeasurementAPIs } from "./API/measurement";
import { AIRoadAPIs } from "./API/road-ai";
import { RoadConstructionAPIs } from "./API/road-construction";
import { SIMAAPIs } from "./API/sima-apis";
import { SolidMeshAPIs } from "./API/solid-mesh-apis";
import { SpreadingCompactionAPIs } from "./API/spreading-compaction-apis";
import { TrenchConstructionAPIs } from "./API/trench-construction";
import { SCDesign } from "./sc-design";
export class EarthBrainViewer extends EarthBrainViewerAPIs {
    constructor(args, settings) {
        super();
        this._scDesign = new SCDesign(args, settings);
    }
}
// This can live anywhere in your codebase:
function applyMixins(derivedCtor, constructors) {
    constructors.forEach((baseCtor) => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach((name) => {
            Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name) ||
                Object.create(null));
        });
    });
}
// Apply the mixins into the base class via
// the JS at runtime
applyMixins(EarthBrainViewer, [
    EarthBrainViewerAPIs,
    RoadConstructionAPIs,
    TrenchConstructionAPIs,
    ArbitraryLineAPIs,
    LineWorkAPIs,
    AIRoadAPIs,
    FlatGroundAPIs,
    MeasurementAPIs,
    DXFAPIs,
    SIMAAPIs,
    Drawing2DImageAPIs,
    SolidMeshAPIs,
    SpreadingCompactionAPIs,
]);
//# sourceMappingURL=sc-design-api.js.map